import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" fill="white"/>
    <g clip-path="url(#clip0_2323_4819)">
    <path d="M9.35308 8.57309L6.47282 15.4451H4.59366L3.17627 9.96092C3.09022 9.62313 3.0154 9.49938 2.75369 9.35707C2.32641 9.12527 1.62081 8.90779 1 8.77281L1.04217 8.57309H4.06704C4.45261 8.57309 4.79922 8.82976 4.88676 9.27377L5.63533 13.2502L7.48538 8.57298H9.35308V8.57309ZM16.7159 13.2014C16.7235 11.3877 14.208 11.2878 14.2253 10.4776C14.2306 10.231 14.4654 9.96882 14.9793 9.90191C15.234 9.86856 15.9359 9.84313 16.7319 10.2094L17.0441 8.75219C16.6164 8.59693 16.066 8.44751 15.3813 8.44751C13.6242 8.44751 12.3876 9.38159 12.3771 10.7191C12.3658 11.7084 13.2598 12.2605 13.9333 12.5892C14.6262 12.9259 14.8587 13.1422 14.856 13.4433C14.8511 13.9043 14.3034 14.1078 13.7916 14.1158C12.898 14.1296 12.3796 13.874 11.9663 13.6819L11.644 15.1874C12.0594 15.3779 12.8261 15.5442 13.6209 15.5526C15.4885 15.5526 16.7102 14.6301 16.7159 13.2014ZM21.3559 15.4451H23L21.5649 8.57309H20.0473C19.7061 8.57309 19.4183 8.77178 19.2908 9.07726L16.6232 15.4451H18.4899L18.8605 14.4186H21.1412L21.3559 15.4451ZM19.3723 13.0102L20.308 10.43L20.8465 13.0102H19.3723ZM11.893 8.57309L10.4231 15.4451H8.64542L10.116 8.57309H11.893Z" fill="#1434CB"/>
    </g>
    <defs>
    <clipPath id="clip0_2323_4819">
    <rect width="22" height="7.10505" fill="white" transform="translate(1 8.44751)"/>
    </clipPath>
    </defs>
  </svg>
`;

export const Visa = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
